import { render } from "./NavItemComponent.vue?vue&type=template&id=4e3ad6ee"
import script from "./NavItemComponent.vue?vue&type=script&lang=js"
export * from "./NavItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__